import { render } from "./UppyUploaderReplace.vue?vue&type=template&id=5e925eda"
import script from "./UppyUploaderReplace.vue?vue&type=script&lang=js"
export * from "./UppyUploaderReplace.vue?vue&type=script&lang=js"

import "./UppyUploaderReplace.vue?vue&type=style&index=0&id=5e925eda&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__